<template>
<div class="chapter">
<div class="inner_page">
<p><a id="p01"></a></p><a id="p01">
<div class="ct"><b>PART ONE</b></div>
<div class="cst"><b>About Green Smoothies</b></div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// kris_9781569759998_oeb_p01_r1.vue?7a393268